import { useQuery } from '@tanstack/react-query';
import { custodianKeys } from '@/services/query-keys/custodian-keys';
import { tradesService } from '@/services/trades/trades-service';

/**
 * Full custodian list for the register tab — ALL custodians, active and
 * inactive (no `is_active` filter, unlike the dropdown's `useCustodians`).
 * Reuses the existing two-step `getAllCustodians` (count, then all rows).
 */
export const useCustodianRegistry = () => {
  return useQuery({
    queryKey: custodianKeys.registry(),
    queryFn: () => tradesService.getAllCustodians(),
    staleTime: 5 * 60 * 1000,
  });
};
